var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"click":function($event){return _vm.$emit('toggle')}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }